import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import ElementPan from 'react-element-pan'
import s from 'react-prefixr'
import { ReactPinchZoomPan, PinchView } from 'react-pinch-zoom-pan'
import { getFood } from './actions'

import Paper from 'material-ui/Paper';
import {GridList, GridTile} from 'material-ui/GridList';
import {CardTitle} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import ActionZoomIn from 'material-ui/svg-icons/action/zoom-in';
import ActionZoomOut from 'material-ui/svg-icons/action/zoom-out';
import Subheader from 'material-ui/Subheader';
import StarBorder from 'material-ui/svg-icons/toggle/star-border';
import TextField from 'material-ui/TextField';

import SessionHeader from '../../components/SessionHeader/SessionHeader'
import ButtonFavorite from '../../components/ButtonFavorite'
import {
  addBookmark,
  deleteBookmark
} from '../Bookmark/actions'
import language from '../../config/language'

const styles = {
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    paddingBottom: 5    
  },
  gridList: {
    overflowY: 'auto',
  },
};

 class Map extends Component {

  constructor(props) {
    super(props);
    this.state = { scale: 1, width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  zoomIn = () => {
    if(this.state.scale < 10)
      this.setState({scale: this.state.scale + 1})
  }

  zoomOut = () => {
    if(this.state.scale > 1)
      this.setState({scale: this.state.scale - 1})
  }

  /* Use the css padding-top to make the container as high as inner content */
  getContainerStyle(ratio) {
    return {
      //width: this.state.width,
      //height: this.state.height,
      paddingTop: ratio.toFixed(2) + '%',
      overflow: 'hidden',
      position: 'relative'
    }
  }

  /* Position inner content absolute */
  getInnerStyle() {
    return {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    }
  }
  
  render() {
    console.log(this.state.width, this.state.height);
    // const ratio = (this.state.height / this.state.width) * 100
    // return (
    //   <ReactPinchZoomPan maxScale={5} render={obj => {
    //     return (
    //       <div style={this.getContainerStyle(ratio)}>
    //         <div style={this.getInnerStyle()}>
    //           <img 
    //             src="ayutthaya-map.jpg"
    //             style={s({
    //               margin: 'auto',
    //               width: 'auto',
    //               height: '100%',
    //               transform: `scale(${obj.scale}) translateY(${obj.y}px) translateX(${obj.x}px)`
    //             })} />
    //         </div>
    //       </div>
    //     )
    //   }} />
    // )
    return (
      // <PinchView backgroundColor='#fff' initalScale={2} maxScale={10} containerRatio={this.state.height / this.state.width * 100}>
      //   <img src="ayutthaya-map.jpg" style={{
      //     margin: 'auto',
      //     width: 'auto',
      //     height: '100%'
      //   }} />
      // </PinchView>
      <div>
        <ElementPan
          width={this.state.width} // Optional width for the ElementPan container
          height={this.state.height} // Optional height for the ElementPan container
          startX={this.state.width/2} // Optional X coordinate to start at
          startY={this.state.height/2} // Optional Y coordinate to start at
          onPanStart={() => {
            /* Pan started! */
          }}
          onPanStop={() => {
            /* Pan ended! */
          }}
          onPan={() => {
            /* Pan move! */
          }}
        >
          <img src="ayutthaya-map.jpg" height={this.state.height*this.state.scale} onMouseDown={e => e.preventDefault()} />
        </ElementPan>
        <div style={{textAlign: 'center'}}>
          <IconButton onClick={()=>{this.zoomIn()}}>
            <ActionZoomIn />
          </IconButton>
          <IconButton onClick={()=>{this.zoomOut()}}>
            <ActionZoomOut />
          </IconButton>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ lang, category, bookmark, ...state }) => ({
  data: state.food.list[lang].data,
  loading: state.food.list.loading,
  error: state.food.list.error,
  lang,
  category,
  bookmark
})
export default connect(mapStateToProps, {
  getFood,
  addBookmark,
  deleteBookmark
})(Map)




// WEBPACK FOOTER //
// ./src/containers/Map/Map.js